import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../../_metronic/_partials/controls";
import {
  createOrganizationCategory,
  fetchOrganizationCategoryById,
  updateOrganizationCategory
} from "../../../_redux/organization-category/organizationCategoryAction";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import OrganizationCategoryEditForm from "./OrganizationCategoryEditForm";

export default function OrganizationCategoryForm({
  history,
  match: {
    params: { id }
  }
}) {
  const dispatch = useDispatch();

  const {
    organizationCategoryForEdit,
    actionsLoading,
    listLoading
  } = useSelector(state => state.superAdminOrganizationCategory, shallowEqual);

  useEffect(() => {
    if (id) {
      dispatch(fetchOrganizationCategoryById(id));
    }
  }, [dispatch, id]);

  const saveCategory = values => {
    if (id) {
      dispatch(updateOrganizationCategory(values)).then(res => {
        toast.success(res.data.message);
        history.push("/admin/master-data/category");
      });
    } else {
      dispatch(createOrganizationCategory(values)).then(res => {
        toast.success(res.data.message);
        history.push("/admin/master-data/category");
      });
    }
  };

  function handleBack() {
    history.goBack();
  }

  return (
    <>
      <LoadingAnimation open={actionsLoading || listLoading} />
      <Card>
        <CardHeader title={`${id ? "Edit" : "Tambah"} Category`}>
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-secondary"
              onClick={handleBack}
            >
              Kembali
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <OrganizationCategoryEditForm
            defaultValues={id ? organizationCategoryForEdit || {} : {}}
            onSubmit={saveCategory}
          />
        </CardBody>
      </Card>
    </>
  );
}
